
import React from 'react';

const DataProvisionObligation = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">XI. No obligation to provide personal data</h3>
      <p className="text-gray-600">
        We do not make the conclusion of contracts with us dependent on you providing us with personal data beforehand. As a customer, you are not generally under a legal or contractual obligation to provide us with your personal data; however, it may be that we can only provide certain offers to a limited extent or not at all if you do not provide the required data. If this should exceptionally be the case within the scope of the products or services offered by us and presented below, you will be notified separately.
      </p>
    </div>
  );
};

export default DataProvisionObligation;
